"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plaintextToRichTextJson = exports.draftContentToPlaintext = exports.draftContentToHtml = exports.draftContentHasText = exports.RichTextEditor = exports.RichTextDisplay = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDraftWysiwyg = require("react-draft-wysiwyg");
var _draftJs = require("draft-js");
require("react-draft-wysiwyg/dist/react-draft-wysiwyg.css");
require("react-frontend-utils/dist/styles.css");
var _dompurify = _interopRequireDefault(require("dompurify"));
var _draftjsToHtml = _interopRequireDefault(require("draftjs-to-html"));
var _ColorPicker = require("./ColorPicker");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
_dompurify["default"].setConfig({
  ADD_ATTR: ['target']
}); //allow "open in new window" html link targets

/**
 * The RichTextEditor displays a WYSIWYG editor for based on draftjs that is converted to HTML for display. This component adds to the 
 * react-draft-wysiwyg editor by adding the ColorPicker component for foreground/background text, replacing empty paragraph elements (<p></p>) with <br> elements
 * to better reflect the user's new/blank line intentions.  To work properly the .css must be included to remove the default margin on <p> elements.
 * 
 * The caller passes the props as follows:
 * 
 * draftContent: this is a json string of previously generated draftjs content, to repopulate the editor. To initialize a blank editor, pass null
 * onChange: a callback function receiving a String argument of the json string of draftjs content, which can be saved and used to repopulate the editor
 * editing: when true, the wysiwyg editor is shown.  When false, the html is rendered.  Note: Dompurify is called to sanitize the generated html.
 * 
 */
var RichTextEditor = exports.RichTextEditor = function RichTextEditor(props) {
  var initialContent;
  if (props.draftContent)
    //If we have content, set it
    initialContent = _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(JSON.parse(props.draftContent)));else initialContent = _draftJs.EditorState.createEmpty(); //blank content if no content

  var _useState = (0, _react.useState)(initialContent),
    _useState2 = _slicedToArray(_useState, 2),
    editorState = _useState2[0],
    setEditorState = _useState2[1];
  var toHtml = function toHtml() {
    var currentContentAsHTML = (0, _draftjsToHtml["default"])((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
    currentContentAsHTML = currentContentAsHTML.replaceAll("<p></p>", "<br>");
    return {
      __html: _dompurify["default"].sanitize(currentContentAsHTML)
    };
  };
  if (props.editing) {
    //show the editor

    return /*#__PURE__*/_react["default"].createElement(_reactDraftWysiwyg.Editor, {
      editorState: editorState,
      toolbarClassName: "toolbarClassName",
      wrapperClassName: "wrapperClassName",
      editorClassName: "editorClassName",
      onEditorStateChange: function onEditorStateChange(editorState) {
        setEditorState(editorState);
        var json = JSON.stringify((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
        if (props.onChange) props.onChange(json);
      },
      toolbar: {
        colorPicker: {
          component: ToolbarColor
        }
      }
    });
  } else {
    //show the html               
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "htmlRender",
      style: {
        width: '100%'
      },
      dangerouslySetInnerHTML: toHtml()
    });
  }
};

/**
 * Convert the draftjs JSON content to html, purifying it
 * @param {String} draftContent, in Json format.  If null, an empty <div/> is returned
 * @returns {String} sanitized html
 */
var draftContentToHtml = exports.draftContentToHtml = function draftContentToHtml(draftContent) {
  var contentAsHTML = "<div/>"; //default if empty
  if (draftContent) contentAsHTML = (0, _draftjsToHtml["default"])(JSON.parse(draftContent));
  contentAsHTML = contentAsHTML.replaceAll("<p></p>", "<br>");
  return _dompurify["default"].sanitize(contentAsHTML);
};

/**
 * The RichTextDisplay renders HTML from a draftjs content string, in cases where you don't need to swap between Editor and display.
 * The caller passes the props as follows:
 * 
 * draftContent: this is a json string of previously generated draftjs content, to repopulate the editor. If nothing is passed, an empty <div/> element is rendered
 * 
 */
var RichTextDisplay = exports.RichTextDisplay = function RichTextDisplay(props) {
  var html = draftContentToHtml(props.draftContent);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "htmlRender",
    style: {
      width: '100%'
    },
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};

/**
 * Utility function to convert plaintext to json suitable for sending to the RichTextDisplay component.  Use this to 
 * upgrade existing plaintext components to richtext, if their initial character does not start with {
 * @param {type} plaintext the plaintext to convert
 * @returns {String} json string 
 */
var plaintextToRichTextJson = exports.plaintextToRichTextJson = function plaintextToRichTextJson(plaintext) {
  var contentState = _draftJs.ContentState.createFromText(plaintext);
  var editorState = _draftJs.EditorState.createWithContent(contentState);
  return JSON.stringify((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
};

/**
 * Extracts plaintext from DraftContent, or an empty string if draftContent is falsy
 * @param {String} draftContent
 * @returns {String} plaintext
 */
var draftContentToPlaintext = exports.draftContentToPlaintext = function draftContentToPlaintext(draftContent) {
  if (!draftContent) return "";

  // Assuming draftContent is the Draft.js raw content
  var contentState = (0, _draftJs.convertFromRaw)(JSON.parse(draftContent));
  var plainText = contentState.getPlainText();
  if (plainText) return plainText;else return "";
};

/**
 * See if the the draftjs JSON content has any actual text in it (not just blocks or formatting)
 * @param {String} draftContent in Json format
 * @returns {Boolean} true if there is text, false if the draftContent is null or empty or has no text
 */
var draftContentHasText = exports.draftContentHasText = function draftContentHasText(draftContent) {
  var plainText = draftContentToPlaintext(draftContent);
  if (plainText)
    // if the string is not empty, there is text content in the draftContent
    return true;else return false;
};
var ToolbarColor = /*#__PURE__*/function (_React$Component) {
  function ToolbarColor() {
    var _this;
    _classCallCheck(this, ToolbarColor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ToolbarColor, [].concat(args));
    _defineProperty(_this, "iconStyle", {
      cursor: 'pointer',
      textAlign: 'center',
      fontFamily: 'serif',
      fontSize: 20,
      fontWeight: 'bold',
      width: 28,
      height: 26
    });
    _defineProperty(_this, "buttonStyle", {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '1px',
      border: '1px solid rgba(0,0,0,.1)',
      height: 30,
      width: 32
    });
    _defineProperty(_this, "containerStyle", {
      marginLeft: 6,
      marginRight: 6,
      display: 'flex',
      gap: 6
    });
    _defineProperty(_this, "onFgChange", function (color) {
      _this.props.onChange('color', color.hex);
    });
    _defineProperty(_this, "onBgChange", function (color) {
      _this.props.onChange('bgcolor', color.hex);
    });
    return _this;
  }
  _inherits(ToolbarColor, _React$Component);
  return _createClass(ToolbarColor, [{
    key: "render",
    value: function render() {
      var fgButton = /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread(_objectSpread({}, this.iconStyle), {}, {
          color: this.props.currentState.color
        })
      }, "T");
      var bgButton = /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread(_objectSpread({}, this.iconStyle), {}, {
          border: '1px solid gray',
          backgroundColor: this.props.currentState.bgColor
        })
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: this.containerStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        title: "Text Color",
        "aria-label": "rdw-color-picker",
        className: "react-draft-wysiwyg-button",
        style: this.buttonStyle
      }, /*#__PURE__*/_react["default"].createElement(_ColorPicker.ColorPicker, {
        color: this.props.currentState.color,
        button: fgButton,
        disableAlpha: true,
        width: 20,
        height: 5,
        onChange: this.onFgChange
      })), /*#__PURE__*/_react["default"].createElement("div", {
        title: "Background Color",
        "aria-label": "rdw-color-picker",
        className: "react-draft-wysiwyg-button",
        style: this.buttonStyle
      }, /*#__PURE__*/_react["default"].createElement(_ColorPicker.ColorPicker, {
        color: this.props.currentState.bgColor,
        button: bgButton,
        disableAlpha: true,
        width: 20,
        height: 5,
        onChange: this.onBgChange
      })));
    }
  }]);
}(_react["default"].Component);
;